<template>
  <div
    :class="[$style.wrapper, activeCard && activeCard.type, isError && $style.error, 'dropzone']"
    :style="{ top: `${top}%`, left: `${left}%`, transform: `rotate(${rotation}deg)`}"
    v-tooltip="activeCard ? activeCard.title : null"
  >
    <svg width="91" height="61" viewBox="0 0 91 61" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.9712 1.98047L73.7636 1.98047C77.4223 1.98047 80.6704 4.32162 81.8274 7.79253L88.4941 27.7925C89.0757 29.5373 89.0757 31.4236 88.4941 33.1684L81.8274 53.1684C80.6704 56.6393 77.4223 58.9805 73.7636 58.9805L10.9712 58.9805C6.27677 58.9805 2.47119 55.1749 2.47119 50.4805L2.47119 10.4805C2.47119 5.78605 6.27677 1.98047 10.9712 1.98047Z" :fill="color" stroke="black" stroke-width="3"/>
    </svg>
    <div v-if="activeCard" :class="$style.icon" v-html="activeCard.icon"></div>
    <div v-else :class="$style.question">?</div>
    <div v-if="activeCard" :class="$style.delete" @click="resetHard"></div>
  </div>
</template>
<script>
export default {
  name: 'container',
  props: {
    filled: Boolean,
    top: Number,
    left: Number,
    rotation: Number,
    order: Number,
  },
  data: () => ({
    activeCard: null,
    isError: false,
  }),
  computed: {
    color() {
      const { activeCard } = this

      if (!activeCard) return 'white'

      return activeCard.type === 'cheater' ? '#FF0000' : '#7395F5'
    },
  },
  methods: {
    reset() {
      this.activeCard = null
    },
    resetHard() {
      this.activeCard.vue.reset()
      this.reset()
    },
    error() {
      this.isError = true
      setTimeout(() => {
        this.isError = false
      }, 1000)
    },
  },
  mounted() {
    this.$el.vue = this
  },
}
</script>
<style lang="scss" module>
@keyframes jello {
  0%,11.1%,to {
    transform: translateZ(0)
  }

  22.2% {
    transform: skewX(-12.5deg) skewY(-12.5deg)
  }

  33.3% {
    transform: skewX(6.25deg) skewY(6.25deg)
  }

  44.4% {
    transform: skewX(-3.125deg) skewY(-3.125deg)
  }

  55.5% {
    transform: skewX(1.5625deg) skewY(1.5625deg)
  }

  66.6% {
    transform: skewX(-.78125deg) skewY(-.78125deg)
  }

  77.7% {
    transform: skewX(.390625deg) skewY(.390625deg)
  }

  88.8% {
    transform: skewX(-.1953125deg) skewY(-.1953125deg)
  }
}

.wrapper {
  width: 9rem;
  height: 6rem;
  position: absolute;
  color: #000;
  transform: translateZ(0);

  & > svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: transform 0.3s ease;
  }
}

.wrapper.error {
  & > svg {
    animation: jello 1s ease forwards;
  }
}

.question {
  @include vtFont;
  font-size: 4.6rem;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}

:global(.drop-active) {
  svg {
    transform: scale(1.5);
  }
}

.icon {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;

  svg {
    position: relative;
    width: auto;
    height: 2rem;
    transform: none;

    path {
      fill: #fff;
    }
  }
}

.delete {
  width: 2.7rem;
  height: 2.7rem;
  cursor: pointer;
  background: url(./assets/cross.svg) no-repeat center;
  background-size: cover;
  position: absolute;
  top: -1.3rem;
  left: 6.5rem;
}
</style>
